export default __webpack_public_path__ + "static/media/kase.64df1020.jpg";